






































































import { Wallet } from "@/models/wallet";
import {
  defineComponent,
  PropType,
  toRefs,
  computed
} from "@vue/composition-api";
import { token, useFilters } from "@/lib/format";
import { usePrices, useUsdPrice } from "@/hooks/use-prices";
import { ERC20TokenInfo } from "@/models/erc20";
import { useCopy } from "@/hooks/use-copy";

export default defineComponent({
  props: {
    wallet: {
      required: true,
      type: Object as PropType<Wallet>
    },
    divider: Boolean,
    selected: Boolean,
    inset: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { wallet } = toRefs(props);
    const open = () => emit("open", wallet.value);
    const remove = () => emit("remove", wallet.value);
    const select = () => emit("select", wallet.value);
    const { prices, baseCurrency, asBaseCurrency } = usePrices();
    const price = useUsdPrice(
      wallet.value.network.etherscanId || -1,
      wallet.value.balance,
      wallet.value.network.decimals,
      prices
    );
    const copy = useCopy;

    const balance = computed(() => {
      const { balance, network } = wallet.value;
      return token(balance, network.symbol, network.decimals);
    });

    const tokens = computed(() => {
      const { tokenByAddress } = usePrices();
      const list = [...(wallet.value?.erc20Tokens || [])];
      const tokens = list
        .map(({ address }) => tokenByAddress(address))
        .filter(t => !!t && t.name && (+(t?.usdtRate || "0") || t.logo))
        .map((t, i) => ({
          ...t,
          balance: list.find(_t => _t.address === t?.address)?.balance || "0"
        }))
        .sort((a, b) =>
          (a as ERC20TokenInfo).name.toLowerCase() <
          (a as ERC20TokenInfo).name.toLowerCase()
            ? -1
            : 0
        );
      return tokens as ERC20TokenInfo[];
    });

    return {
      ...useFilters(),
      open,
      remove,
      select,
      balance,
      price,
      prices,
      tokens,
      asBaseCurrency,
      baseCurrency,
      copy
    };
  }
});
